<!--
  成果的详情
    + 可以审核成果
        当其状态为待审核时
    + 查看成果详情
 -->
<template>
  <div class="detail">
    <detail-header title="成果详情" />
    <div class="detail_main page_width" v-loading="loading">
      <div class="main_content">
        <info-item
          :label-width="labelWidth"
          label="成果名称"
          :value="form.title">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="成果类型"
          :value="form.achievementType">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="成果第一完成人"
          :value="form.firstCompletedBy">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="成果持有单位"
          :value="form.holdUnit">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="所在区域"
          :value="form.region">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="产业特长"
          :value="getIndustrySectorNames(form.industries)">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="技术领域"
          :value="getTechnicalNames(form.technical)">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="成熟度"
          :value="form.maturity">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="成果描述"
          :value="form.description">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="合作方式"
          :value="form.cooperationMode ? form.cooperationMode.toString() : ''">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="交易价格"
          :value="form.price">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="成果资料"
          value-type="file-list"
          :value="form.attachments || []">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="联系人"
          :value="form.contactName">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="联系电话"
          :value="form.contactNumber">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="联系邮箱"
          :value="form.contactEmail">
        </info-item>
        <info-item
          :label-width="labelWidth"
          label="是否为成果代理人"
          :value="{
            1: '是',
            0: '否',
          }[form.proxyAgent]">
        </info-item>
        <template v-if="form.proxyAgent === 1">
          <info-item
            :label-width="labelWidth"
            label="代理人单位"
            :value="form.proxyUnit">
          </info-item>
          <info-item
            :label-width="labelWidth"
            label="上传代理协议"
            value-type="file-list"
            :value="form.agentAgreement || []">
          </info-item>
        </template>
        <template v-if="form.proxyAgent === 0">
          <info-item
            :label-width="labelWidth"
            label="是否委托平台服务商推广"
            :value="{
              1: '是',
              0: '否',
            }[form.isEntrust]">
          </info-item>
        </template>
        <div
          class="btn_box tw-mt-40px"
          v-if="form.logicStatus === globalVar.ACHIEVEMENT_STATUS_0">
          <el-button
            type="primary"
            size="small"
            :loading="btnLoading"
            @click="onAudit(globalVar.ACHIEVEMENT_STATUS_1)">通过
          </el-button>
          <el-button
            type="danger"
            size="small"
            :loading="btnLoading"
            plain
            @click="onAudit(globalVar.ACHIEVEMENT_STATUS_2)">驳回
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api'
import globalVar from '@/configs/globalVar'
export default {
  data () {
    return {
      // 页面loading
      loading: false,
      btnLoading: false,
      labelWidth: '180px',
      // 表单数据
      form: {}
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    // 技术领域
    technicalList () {
      return this.$store.state.technicalList
    },
    // 拿到技术领域的id字符串
    getTechnicalNames () {
      return (technical = []) => {
        let result = ''

        this.technicalList.forEach(item => {
          if (technical.includes(item.id)) {
            result += result === '' ? item.name : ',' + item.name
          }
        })
        return result
      }
    },
    // 行业领域下拉列表
    industrySectorList () {
      return this.$store.state.industrySectorList
    },
    // 拿到行业领域的id字符串
    getIndustrySectorNames () {
      return (idList = []) => {
        let result = ''

        this.industrySectorList.forEach(item => {
          if (idList.includes(item.id)) {
            result += result === '' ? item.name : ',' + item.name
          }
        })
        return result
      }
    }
  },
  created () {
    // 获取成果详情
    this.getAchievementDetail()
  },
  methods: {
    // 获取成果详情
    getAchievementDetail () {
      this.loading = true
      api.getAchievementDetail(this.id).then(res => {
        if (res.data.code === 0) {
          this.form = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('请求出错')
      }).finally(() => {
        this.loading = false
      })
    },
    // 通过或拒绝
    onAudit (logicStatus) {
      // 如果是已拒绝 则需要填写拒绝理由
      if (logicStatus === globalVar.ACHIEVEMENT_STATUS_2) {
        this.$prompt('请输入驳回原因', '提示', {
          confirmButtonText: '驳回',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '请输入驳回原因',
          inputPlaceholder: '请输入驳回原因'
        }).then(({ value }) => {
          this.onStatus('', '', logicStatus, value)
        }).catch(() => {
        })
      } else {
        this.$msgbox({
          title: '确认',
          message: '请确认你的操作',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              this.onStatus(instance, done, logicStatus)
            } else {
              done()
            }
          }
        })
      }
    },
    // 审核成果
    onStatus (instance, done, logicStatus, reason = '') {
      if (instance) {
        instance.confirmButtonLoading = true
      }
      this.btnLoading = true
      api.updateAchievementStatus(this.id, {
        logicStatus, // 被更新的状态
        reason // 驳回原因
      }).then(res => {
        if (res.data.code === 0) {
          this.$message.success('操作成功')
          this.getAchievementDetail()
        } else {
          this.$message.error(res.data.message)
        }
        done && done()
      }).catch(err => {
        console.log(err)
        this.$message.error('请求出错')
      }).finally(() => {
        this.btnLoading = false
        if (instance) {
          instance.confirmButtonLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail {
  .detail_main {
    padding: 30px 0;
    .main_content {
      width: 560px;
      margin: 0 auto;

      .btn_box {
        padding-left: 180px;
      }
    }
  }
}
</style>
